import {
  FETCH_DOC_REQUEST,
  FETCH_DOC_SUCCESS,
  FETCH_DOC_FAILURE,
  SEARCH_DOCS,
  SEARCH_DOCS_RESULTS,
  SEARCH_DOCS_CLEAR,
} from "../actions/types";

const initialState = {
  // Cache: docPath → markdown string
  cache: {},
  currentDocPath: null,
  loading: false,
  error: null,
  // Search
  searchQuery: "",
  searchResults: [],
  searchLoading: false,
};

const docsReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_DOC_REQUEST:
      return {
        ...state,
        currentDocPath: action.payload,
        loading: true,
        error: null,
      };

    case FETCH_DOC_SUCCESS:
      return {
        ...state,
        loading: false,
        cache: {
          ...state.cache,
          [action.payload.docPath]: action.payload.content,
        },
      };

    case FETCH_DOC_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };

    case SEARCH_DOCS:
      return { ...state, searchQuery: action.payload, searchLoading: true };

    case SEARCH_DOCS_RESULTS:
      return { ...state, searchLoading: false, searchResults: action.payload };

    case SEARCH_DOCS_CLEAR:
      return { ...state, searchQuery: "", searchResults: [], searchLoading: false };

    default:
      return state;
  }
};

export default docsReducer;
